/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S4_Item2_TextInputs */

const tr_cerez_s4_item2_text = /** @type {(inputs: Cerez_S4_Item2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`belirli bir süre cihazınızda saklanır (genellikle 12 aya kadar). Tercih hatırlama amacıyla kullanılır.`)
};

const en_cerez_s4_item2_text = /** @type {(inputs: Cerez_S4_Item2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`are stored on your device for a certain period (usually up to 12 months). They are used to remember preferences.`)
};

const de_cerez_s4_item2_text = /** @type {(inputs: Cerez_S4_Item2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`werden für einen bestimmten Zeitraum auf Ihrem Gerät gespeichert (in der Regel bis zu 12 Monate). Sie werden zum Speichern von Einstellungen verwendet.`)
};

const ru_cerez_s4_item2_text = /** @type {(inputs: Cerez_S4_Item2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`хранятся на вашем устройстве в течение определённого срока (обычно до 12 месяцев). Используются для сохранения настроек.`)
};

/**
* | output |
* | --- |
* | "are stored on your device for a certain period (usually up to 12 months). They are used to remember preferences." |
*
* @param {Cerez_S4_Item2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s4_item2_text = /** @type {((inputs?: Cerez_S4_Item2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S4_Item2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s4_item2_text(inputs)
	if (locale === "de") return de_cerez_s4_item2_text(inputs)
	if (locale === "ru") return ru_cerez_s4_item2_text(inputs)
	return tr_cerez_s4_item2_text(inputs)
});